import { useMemo } from 'react'
import { Editor } from 'slate'
import { useSlate } from 'slate-react'

import { Dropdown } from 'core-components/library/dropdown'
import { BaseCrud, Static } from 'core-components/types'

import { DEFAULT_FONT_SIZE } from './constants/fontSize'
import { IFontSizeDropdownProps } from './models/IFontSizeDropdownProps'

export const FontSizeDropDown = ({ fontSizes, disabled }: IFontSizeDropdownProps) => {
  const editor = useSlate()
  const currentSize = Editor.marks(editor)?.['fontSize']
  const value = currentSize != null ? String(currentSize) : ''

  const source = useMemo(() => {
    const items = fontSizes.map((size) => ({ key: String(size), value: String(size) }))
    return new BaseCrud({
      fetcher: new Static(items),
      defaultPaging: { page: 0, pageSize: items.length },
      keyField: 'key',
    })
  }, [fontSizes])

  return (
    <Dropdown
      source={source}
      caption={'value'}
      label={'Font size'}
      value={value}
      disabled={disabled}
      onChange={(selected) => {
        const size = Number(selected)
        if (size) {
          Editor.addMark(editor, 'fontSize', size)
        }
      }}
      renderFunction={(item) => (
        <div>{Number(item.key) === DEFAULT_FONT_SIZE ? `${item.value} (default)` : item.value}</div>
      )}
    />
  )
}
